import { AxiosResponse } from 'axios'

//axios
import { axiosBackendInstance } from '../axiosInstance'
import axiosWebInstance from '../axiosWebInstance'
//types
import {
  OrderGiftCardRequestBody,
  OrderGiftCardResponse,
  OrderGiftCardByCampaignRequestBody,
  OrderGiftCardByCampaignResponse,
} from 'types'

export const getOrderById = async (orderId: string) => {
  return axiosBackendInstance.get(`/api/v1/orders/${orderId}`)
}

export const orderGiftCard = async (
  data: OrderGiftCardRequestBody
): Promise<AxiosResponse<OrderGiftCardResponse, Error>> => {
  return axiosWebInstance.post('/api/v1/orders', data)
}

export const orderGiftCardByCampaign = async (
  data: OrderGiftCardByCampaignRequestBody
): Promise<AxiosResponse<OrderGiftCardByCampaignResponse, Error>> => {
  return axiosWebInstance.post(`/api/v1/orders/campaign`, data)
}

export const getAllUserOrders = async (userId: string) => {
  return axiosWebInstance.get(`/api/v1/orders/user/${userId}`)
}
